import { DotsSixVertical } from '@phosphor-icons/react';
import classNames from 'classnames';
import { type ForwardedRef, forwardRef, useEffect, useRef } from 'react';
import { resizeConfigPanel } from '../../../../utils';
import { usePageEditor } from '../../../PageEditorProvider';
import PageConditions from '../../pageConditions/PageConditions';
import { PageConditionProvider } from '../../pageConditions/PageConditionsProvider';
import { useComposer } from '../ComposerProvider';
import ElementConfig from './ElementConfig';
import ElementConfigInner from './ElementConfigInner';

const ConfigPanel = (_: unknown, ref: ForwardedRef<HTMLDivElement | null>) => {
    const { state } = usePageEditor();
    const { preview, showPageConditions, tab } = state;
    const { dragDropElements, elementToEdit } = useComposer();

    const elementToConfigure = dragDropElements
        ? dragDropElements.find((element) => element.id === elementToEdit)
        : null;

    const classes = classNames({
        'sidebar-right': true,
        preview,
    });

    const resizeRef = useRef(null);
    const sideBarRef = useRef(null);
    const sideBarContentRef = useRef<HTMLDivElement>(null);

    const footerPortalId = tab?.key ? `sidebar-right-footer-portal-${tab.key}` : '';

    // biome-ignore lint/correctness/useExhaustiveDependencies: Requires dedicated refactor to use correct element
    useEffect(() => {
        if (
            typeof ref !== 'function' &&
            sideBarRef.current !== null &&
            resizeRef.current !== null &&
            ref !== null &&
            ref.current !== null
        ) {
            resizeConfigPanel(sideBarRef.current, resizeRef.current, ref.current);
        }
    }, []);

    return (
        <aside ref={sideBarRef} className={classes} data-testid="sidebar-right">
            <button tabIndex={-1} className="sidebar-resize" ref={resizeRef} type="button">
                <DotsSixVertical size={20} />
            </button>
            <div ref={sideBarContentRef} className="sidebar-right-content">
                {showPageConditions ? (
                    <PageConditionProvider>
                        <PageConditions parentContainerRef={sideBarContentRef} />
                    </PageConditionProvider>
                ) : (
                    <ElementConfigInner showConfig={elementToConfigure}>
                        <ElementConfig key={elementToConfigure?.id} />
                    </ElementConfigInner>
                )}
            </div>
            <div className="sidebar-right-footer" id={footerPortalId} />
        </aside>
    );
};

export default forwardRef(ConfigPanel);
